import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';

/**
 * StatsCards - Display statistics in a grid of cards
 *
 * @param {Object} props
 * @param {Array} props.stats - Array of stat objects with { label, value, color }
 * @param {number} props.columns - Number of columns (default: auto based on stats length)
 */
const StatsCards = ({ stats = [], columns }) => {
  const gridColumns = columns || Math.min(stats.length, 4);
  const mdSize = 12 / gridColumns;

  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      {stats.map((stat, index) => (
        <Grid item xs={12} md={mdSize} key={index}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{ color: 'text.secondary', mb: 1 }}
              >
                {stat.label}
              </Typography>
              <Typography
                variant="h3"
                sx={{ fontWeight: 600, color: stat.color || 'primary.main' }}
              >
                {stat.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;
